module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Ruedlingen-b0d6bb4b06acdc80c7ff58eecaa21b40.png";